import React, { MouseEvent, ReactNode } from "react";
import { clsx } from "clsx";

type Props = {
  type?: "submit" | "button";
  children: ReactNode;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  size?: "normal" | "small" | "large" | "icon";
  disabled?: boolean;
};

/**
 * Renders <button> element.
 */
export const Button = ({ type = "button", children, onClick, size = "normal", disabled }: Props) => {
  const className = clsx("button print-none", {
    "small": size === "small",
    "large": size === "large",
    "icon": size === "icon"
  });

  return (
    <button type={type} onClick={onClick} className={className} disabled={disabled}>
      {children}
    </button>
  );
};
